import { c as _c } from "react/compiler-runtime";
function SkeletonCard() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-mb-5 tw-flex tw-items-start tw-justify-between"><div className="tw-h-5 tw-w-32 tw-rounded tw-bg-neutral-700" /><div className="tw-size-10 tw-rounded-lg tw-bg-neutral-700" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-flex-1 tw-space-y-2"><div className="tw-h-3 tw-w-12 tw-rounded tw-bg-neutral-700" /><div className="tw-h-10 tw-w-20 tw-rounded tw-bg-neutral-700" /><div className="tw-h-3 tw-w-24 tw-rounded tw-bg-neutral-700" /><div className="tw-h-4 tw-w-16 tw-rounded tw-bg-neutral-700" /></div>;
    t2 = <div className="tw-w-px tw-bg-neutral-700/50" />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-animate-pulse tw-rounded-xl tw-border tw-border-neutral-800 tw-bg-[#0f1318] tw-p-5">{t0}<div className="tw-flex tw-gap-6">{t1}{t2}<div className="tw-flex-1 tw-space-y-2"><div className="tw-h-3 tw-w-16 tw-rounded tw-bg-neutral-700" /><div className="tw-h-8 tw-w-16 tw-rounded tw-bg-neutral-700" /><div className="tw-h-3 tw-w-24 tw-rounded tw-bg-neutral-700" /><div className="tw-h-4 tw-w-16 tw-rounded tw-bg-neutral-700" /></div></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export default function MetricsSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-grid tw-grid-cols-1 tw-gap-4 lg:tw-grid-cols-2 xl:tw-grid-cols-3"><SkeletonCard /><SkeletonCard /><SkeletonCard /><SkeletonCard /><SkeletonCard /><SkeletonCard /><SkeletonCard /><SkeletonCard /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}